import useListLocationDeliveryKpis, {
  listLocationDeliveryKpisConfigs,
} from './useListLocationDeliveryKpis'
import useListLocationGroupDeliveryKpis, {
  listLocationGroupDeliveryKpisConfigs,
} from './useListLocationGroupDeliveryKpis'

export const configs = {
  listLocationGroupDeliveryKpis: listLocationGroupDeliveryKpisConfigs,
  listLocationDeliveryKpis: listLocationDeliveryKpisConfigs,
}

export const api = {
  listLocationGroupDeliveryKpis: useListLocationGroupDeliveryKpis,
  listLocationDeliveryKpis: useListLocationDeliveryKpis,
}
